class WishlistToastComponent extends HTMLElement {
  #timeout = null;

  connectedCallback() {
    window.addEventListener('wishlist-toast', this.#handleToast);
    this.querySelector('[ref="toast"]')?.addEventListener('click', () => {
      window.dispatchEvent(new CustomEvent('open-wishlist'));
    });
  }

  disconnectedCallback() {
    window.removeEventListener('wishlist-toast', this.#handleToast);
    if (this.#timeout) clearTimeout(this.#timeout);
  }

  #handleToast = (event) => {
    const message = event.detail?.message;
    if (!message) return;

    const drawerDialog = document.querySelector('wishlist-drawer-component [ref="dialog"]');
    if (drawerDialog?.open) return;

    this.#show(message, event.detail?.image);
  };

  #show(message, imageUrl) {
    const toast = this.querySelector('[ref="toast"]');
    const toastMessage = this.querySelector('[ref="toastMessage"]');
    const toastImage = this.querySelector('[ref="toastImage"]');
    if (!toast || !toastMessage) return;

    if (this.#timeout) {
      clearTimeout(this.#timeout);
      this.#timeout = null;
    }

    toastMessage.textContent = message;

    const smallImageUrl = imageUrl ? resizeShopifyCdnUrl(imageUrl, 60) : null;

    if (toastImage) {
      if (smallImageUrl) {
        toastImage.src = smallImageUrl;
        toastImage.hidden = false;
      } else {
        toastImage.hidden = true;
      }
    }

    toast.hidden = false;

    requestAnimationFrame(() => {
      toast.classList.add('visible');
    });

    this.#timeout = setTimeout(() => {
      toast.classList.remove('visible');
      setTimeout(() => {
        toast.hidden = true;
      }, 300);
      this.#timeout = null;
    }, 3000);
  }
}

const resizeShopifyCdnUrl = (url, width) => {
  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('width', width);
    return parsed.origin === window.location.origin
      ? parsed.href.replace(parsed.origin, '')
      : parsed.href;
  } catch {
    return url;
  }
};

if (!customElements.get('wishlist-toast-component')) {
  customElements.define('wishlist-toast-component', WishlistToastComponent);
}
